import PropTypes from 'prop-types';

export default PropTypes.shape({
  pathname: PropTypes.string,
  search: PropTypes.string,
  hash: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object,
});
